module.exports = __webpack_public_path__ + "img/album.6e72989e.svg";